import axios from "axios";
const UNAUTHORIZED = 401;
let apiClientIsInitialized = false;
let apiClient;
const initApiClient = (baseUrl, onUnauthorizedResponse) => {
    apiClient = axios.create({
        baseURL: baseUrl,
        withCredentials: true,
        xsrfCookieName: "XSRF-TOKEN",
        xsrfHeaderName: "X-XSRF-TOKEN",
        // Security enhancements
        timeout: 30000, // 30 second timeout
        maxRedirects: 5, // Limit redirects
        validateStatus: (status) => status >= 200 && status < 300,
        // Prevent SSRF attacks
        maxContentLength: 50 * 1024 * 1024, // 50MB limit
    });
    // Enhanced response interceptor with better error handling
    apiClient.interceptors.response.use((response) => response, (error) => {
        const { response, config } = error;
        // Log security-relevant errors
        if ((response === null || response === void 0 ? void 0 : response.status) === UNAUTHORIZED) {
            console.warn('Unauthorized request detected:', {
                url: config === null || config === void 0 ? void 0 : config.url,
                method: config === null || config === void 0 ? void 0 : config.method,
            });
            if (onUnauthorizedResponse) {
                onUnauthorizedResponse();
            }
        }
        return Promise.reject(error);
    });
    // Request interceptor for additional security
    apiClient.interceptors.request.use((config) => {
        // Validate URLs to prevent SSRF
        if (config.url && config.url.includes('://')) {
            const url = new URL(config.url, config.baseURL);
            if (!['http:', 'https:'].includes(url.protocol)) {
                throw new Error('Invalid protocol detected');
            }
        }
        return config;
    }, (error) => Promise.reject(error));
    apiClientIsInitialized = true;
    return apiClient;
};
const getApiClient = () => {
    if (!apiClientIsInitialized) {
        throw new Error("Client is not yet initialized. Call the appropriate init function first");
    }
    return apiClient;
};
export { initApiClient, getApiClient };
